import type { ReactElement } from "react"
import type { DomainCheck } from "@onestore/api/domainSearch"
import AlignContentOrg from "@onestore/hel/dist/components/organisms/AlignContentOrg"
import PushOrg from "@onestore/hel/dist/components/organisms/PushOrg"
import type Theme from "@onestore/hel/dist/typings/theme"
import DomainAddButton from "@gatsby-plugin-domain-search/components/Button/DomainAddButton"
import { Price } from "@gatsby-plugin-domain-search/components/MainResultBox/Price"

type AsideProps = {
  mainDomain: DomainCheck.Result
  eventSource?: string
  onNextButtonClick?: { (): void }
  buttonColor?: Theme.Color
  buttonDataTestId?: string
  onDomainSelected?: (domainResult: DomainCheck.Result) => void
  selectedFqdns?: string[]
}
export function Aside({
  mainDomain,
  eventSource,
  onNextButtonClick,
  buttonColor,
  buttonDataTestId,
  onDomainSelected,
  selectedFqdns,
}: AsideProps): ReactElement<AsideProps> {
  return (
    <AlignContentOrg
      horizontalAlign={{
        large: "right",
        medium: "right",
        small: "left",
      }}
    >
      <PushOrg bottomSpace={2}>
        <AlignContentOrg
          horizontalAlign={{
            large: "right",
            medium: "right",
            small: "left",
          }}
        >
          <Price domain={mainDomain} />
        </AlignContentOrg>
      </PushOrg>

      <DomainAddButton
        color={buttonColor || "success"}
        isWider
        domain={mainDomain}
        eventSource={eventSource}
        onNextButtonClick={onNextButtonClick}
        hasOverriddenSuccessButtonColor={!!buttonColor}
        buttonDataTestId={buttonDataTestId}
        onDomainSelected={onDomainSelected}
        selectedFqdns={selectedFqdns}
      />
    </AlignContentOrg>
  )
}
